
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy/cookie-policy",
      function () {
        return require("private-next-pages/privacy/cookie-policy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy/cookie-policy"])
      });
    }
  